import cx from 'classnames';
import {CSSProperties} from 'react';
import {DEFAULT_CANVAS_HEIGHT, DEFAULT_CANVAS_WIDTH} from '~/common/canvas/fabric';
import './MaskingFilter.sass';

interface MaskingFilterProps {
  galleryImg: string;
  templateDefault: string;
  uyoPosition: {
    left: number;
    top: number;
    height: number;
    width: number;
    scaleX: number;
    scaleY: number;
  };
  isMobile: boolean;
}

export const MaskingFilter = ({
  galleryImg,
  templateDefault,
  uyoPosition,
  isMobile,
}: MaskingFilterProps) => {
  const {left, top, width, height, scaleX, scaleY} = uyoPosition;
  let styles: {
    top: string;
    height: string;
    left?: string;
    width?: string;
    objectFit: string;
  } = {
    top: `${(top / DEFAULT_CANVAS_HEIGHT) * 100}%`,
    height: `${((height * scaleY) / DEFAULT_CANVAS_HEIGHT) * 100}%`,
    objectFit: 'cover',
  };

  styles = isMobile
    ? styles
    : {
        ...styles,
        left: `${(left / DEFAULT_CANVAS_WIDTH) * 100}%`,
        width: `${((width * scaleX) / DEFAULT_CANVAS_WIDTH) * 100}%`,
      };

  return (
    <div className="masking-filter--container">
      <img
        id="masking-filter-uploaded-img"
        className={cx('masking-filter--item masking-filter--img masking-filter--img-landscape')}
        src={galleryImg}
        alt=""
        data-qa-id="gallery-template__user-upload"
        style={styles as CSSProperties}
      />
      <img
        id="masking-filter-default-template"
        className="masking-filter--item masking-filter--template"
        src={templateDefault}
        alt=""
        data-qa-id="gallery-template__image"
      />
    </div>
  );
};
